import { render, staticRenderFns } from "./VatInvoice.vue?vue&type=template&id=717922e6&scoped=true&"
import script from "./VatInvoice.vue?vue&type=script&lang=js&"
export * from "./VatInvoice.vue?vue&type=script&lang=js&"
import style0 from "./VatInvoice.vue?vue&type=style&index=0&id=717922e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717922e6",
  null
  
)

export default component.exports